export default "__VITE_ASSET__af4ccec7__"